import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import '../ScrollGroup/index.mjs';
import { StickyGridContext } from './context.mjs';
import { ScrollGroup } from '../ScrollGroup/ScrollGroup.mjs';
import { useScrollGroupTo } from '../ScrollGroup/useScrollGroupTo.mjs';
import { useScrollGroupContext } from '../ScrollGroup/context.mjs';
"use strict";
function StickyGrid({
  children,
  templateColumns,
  gap
}) {
  const wrapperRef = useRef(null);
  const [isAtMinX, setIsAtMinX] = useState(true);
  const [isAtMaxX, setIsAtMaxX] = useState(true);
  const evaluateXEndpoints = useCallback(element => {
    if (element.scrollLeft === 0) {
      if (!isAtMinX) {
        setIsAtMinX(true);
      }
    } else if (isAtMinX) {
      setIsAtMinX(false);
    }
    if (element.scrollLeft + 1 >= element.scrollWidth - element.clientWidth) {
      if (!isAtMaxX) {
        setIsAtMaxX(true);
      }
    } else if (isAtMaxX) {
      setIsAtMaxX(false);
    }
  }, [isAtMaxX, isAtMinX]);
  const value = useMemo(() => ({
    templateColumns,
    gap,
    isAtMaxX,
    isAtMinX,
    setIsAtMaxX,
    setIsAtMinX
  }), [isAtMaxX, isAtMinX, templateColumns, gap]);
  return /* @__PURE__ */jsx(ScrollGroup, {
    onScrollItem: evaluateXEndpoints,
    onAddItem: evaluateXEndpoints,
    onResizeItem: evaluateXEndpoints,
    children: /* @__PURE__ */jsx(StickyGridProvider, {
      value,
      children: /* @__PURE__ */jsx(StyledStickyGrid, {
        ref: wrapperRef,
        children
      })
    })
  });
}
function StickyGridProvider({
  value,
  children
}) {
  const scrollTo = useScrollGroupTo();
  const {
    scrollGroupItemsRef
  } = useScrollGroupContext();
  return /* @__PURE__ */jsx(StickyGridContext.Provider, {
    value: useMemo(() => ({
      ...value,
      scrollGroupItemsRef,
      scrollTo
    }), [scrollGroupItemsRef, scrollTo, value]),
    children
  });
}
const StyledStickyGrid = styled.div`
  position: relative;
`;
export { StickyGrid };
//# sourceMappingURL=StickyGrid.mjs.map
